import { createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { titanApi } from "../services/API/titanApi";

export const reset = createAction("reset");
export const resetdeckblatt = createAction("resetdeckblatt");
export const resetproject = createAction("resetproject");
export const resetwithoutdeckblatt = createAction("resetwithoutdeckblatt");

function ResetAllParameter() {
  return (dispatch) => {
    dispatch(reset());
    dispatch(resetdeckblatt());
    dispatch(resetproject());
    dispatch(
      titanApi.util.invalidateTags([
        "allBohrkronen",
        "Product",
        "CarryElement",
        "Tragglied",
        "CharakteristischenEinwirkungen",
        "RefCapacity",
        "DesignCombination",
        "allEmailDistributionLists",
      ])
    );
    toast?.success("All parameters cleared");
    return Promise.resolve();
  };
}

export function ResetAllParametersWithoutDeckblatt() {
  return (dispatch) => {
    dispatch(reset());
    dispatch(resetproject());
    dispatch(
      titanApi.util.invalidateTags([
        "allBohrkronen",
        "Product",
        "CarryElement",
        "Tragglied",
        "CharakteristischenEinwirkungen",
        "RefCapacity",
        "DesignCombination",
        "allEmailDistributionLists",
      ])
    );
    return Promise.resolve();
  };
}

export default ResetAllParameter;
